<div class="trinka_cloud_wrap">
    <div id="particles-js"></div>
    <div class="cloud_top_banners">
        <div class="container">
            <div class="row">
                <div class="col-lg-6">
                    <div class="trinka_cloud_banner_text">
                        <span>개인용 사전</span>
                        <h1>개인용 사전으로 트링카 맞춤 설정</h1>
                        <p>개인용 사전을 사용하면 새 용어에 대한 철자 오류 경고를 피할 수 있습니다. 브랜드 이름이나 새로운 기술과 같이 트링카가 아직 알지 못하는 단어를 사전에 추가하기만 하면 어디에서
                            글을 쓰든
                            <br>트링카가 이를 기억해 드립니다.</p>
                        <a href="https://cloud.trinka.ai/signup?_rg=KR" id="autoEditGetStart" target="_blank">시작하기</a>
                    </div>
                </div>
                <div class="col-lg-6">
                    <div class="trinka_cloud_banner_img">
                        <img src="../../../assets/images/Personal-Dictionary.png" alt="dictionary">
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="SectionHowItWrok">
        <div class="container">
            <div class="row">
                <div class="col-xl-6">
                    <div class="ImgSectionHowItWrok">
                        <a href="" data-toggle="modal" data-target="#wordPluginPopup" id="VewiVideoSection">
                            <img src=".././../../assets/images/MyDicitonayThumbnail.png" alt="thumbnail" class="img-fluid eposter-img">
                        </a>
                    </div>
                </div>
                <div class="col-xl-6">
                    <div class="contentSectionHowItWrok">
                        <h2>이렇게 사용하세요</h2>
                        <div class="HeadingSubLine"></div>
                        <p style="margin-bottom: 10px;">이해하기 쉬운 안내 동영상을 통해 개인용 사전 구축 작업을 바로 시작해 보세요.</p>
                        <p style="margin-bottom: 10px;">트링카를 최대한 활용할 수 있도록 단계별로 상세하게 안내해 드립니다. 더 궁금한 사항이 있으신가요?
                            <a style="color: #0000ff;" (click)="scroll(target)" class="link">여기</a>에서 FAQ를 찾아보세요.</p>
                    </div>
                </div>

            </div>
        </div>
    </div>

    <div class="keyFeatureSection">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <h2>트링카 개인용 사전의 주요 기능</h2>
                    <div class="HeadingSubLine"></div>
                    <p style="margin-bottom: 40px;">불필요한 단어 플래그를 제거하여 글쓰기 경험을 원활하게 만들어 드립니다.</p>
                </div>
            </div>
        </div>
    </div>

    <div class="writeToolboxs_section">
        <div class="writeToolbox_inner_sections" style="background-image: url('../../../assets/images/toolbox_backgrond_browser_plugin_r.png');">
            <div class="container">
                <div class="row">
                    <div class="col-lg-5">
                        <div class="toolbox_img_content">
                            <img src="../../../assets/images/correct-spelling.png" alt="correct-spelling" class="img-fluid">
                        </div>
                    </div>
                    <div class="col-lg-7">
                        <div class="toolbox_text_content">
                            <h3>단어 분류</h3>
                            <p>사전에 추가한 단어를 올바른 철자, 기술적 절차 이름, 생물학적 이름, 제품 이름 등에 따라 구성할 수 있습니다. 트링카는 사용할수록 성능이 좋아집니다.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="writeToolbox_inner_sections">
            <div class="container">
                <div class="row">
                    <div class="col-lg-7">
                        <div class="toolbox_text_content">
                            <h3>대소문자 구분 조정</h3>
                            <p>대/소문자와 일치하는 경우 사전 용어를 무시할지 일치와 관계없이 무시할지 여부를 트링카에서 제어할 수 있습니다.</p>
                        </div>
                    </div>
                    <div class="col-lg-5">
                        <div class="toolbox_img_content">
                            <img src="../../../assets/images/case-sensitive.png" alt="case-sensitive" class="img-fluid">
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="writeToolbox_inner_sections" style="background-image: url('../../../assets/images/toolbox_backgrond_browser_plugin_r.png');">
            <div class="container">
                <div class="row">
                    <div class="col-lg-5">
                        <div class="toolbox_img_content">
                            <img src="../../../assets/images/american-english.png" alt="american-english" class="img-fluid">
                        </div>
                    </div>
                    <div class="col-lg-7">
                        <div class="toolbox_text_content">
                            <h3>영어 유형 선택</h3>
                            <p>트링카를 사용하면 추가된 용어를 영어 유형이 일치할 때 무시할지, 일치 여부와 관계 없이 무시할지 여부를 제어할 수 있습니다.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="writeToolbox_inner_sections">
            <div class="container">
                <div class="row">
                    <div class="col-lg-7">
                        <div class="toolbox_text_content">
                            <h3>플랫폼 간 동기화</h3>
                            <p>사전에 추가한 모든 단어는 모든 플랫폼에서 실시간으로 자동 동기화됩니다. 트링카 사전은 Cloud 편집기, MS Word 추가 기능, 브라우저 플러그인을 가리지 않고
                                어디에서나 구동됩니다.</p>
                        </div>
                    </div>
                    <div class="col-lg-5">
                        <div class="toolbox_img_content noBackgroundColor syncAcrossImages">
                            <img src="../../../assets/images/SyncAcrossPlatforms.png" alt="platforms" class="img-fluid" style="max-width: 300px;">
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="writeToolbox_inner_sections" style="background-image: url('../../../assets/images/toolbox_backgrond_browser_plugin_r.png');">
            <div class="container">
                <div class="row">
                    <div class="col-lg-5">
                        <div class="toolbox_img_content noBackgroundColor">
                            <img src="../../../assets/images/MyDictionary_Brand-tone.png" alt="dictionary" class="img-fluid">
                        </div>
                    </div>
                    <div class="col-lg-7">
                        <div class="toolbox_text_content">
                            <h3>브랜드 톤 유지
                                <span>기업</span>
                            </h3>
                            <p>조직에서 사용하는 어휘와 새 용어를 추가하여 모든 커뮤니케이션에서 브랜드 분위기를 유지하고 글쓰기 지원을 맞춤화해 보세요.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>


    <div class="cloud_key_features" style="display: none;">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <div class="key_features_heading">
                        <h2>트링카 개인용 사전의 주요 기능</h2>
                        <div class="HeadingSubLine"></div>
                        <p>불필요한 단어 플래그를 제거하여 글쓰기 경험을 원활하게 만들어 드립니다.
                        </p>
                    </div>
                </div>
            </div>
            <div class="row">

                <div class="col-lg-4 col-md-6">
                    <div class="features_cards">
                        <img src="../../../assets/images/BuildYourVeryOwnDictionary.png" alt="build">
                        <h3>Build Your Very Own Dictionary</h3>
                        <p>Create your own dictionary by adding terms as you use Trinka or just add them all in one go. You
                            can edit and delete words any time.
                        </p>
                    </div>
                </div>

                <div class="col-lg-4 col-md-6">
                    <div class="features_cards">
                        <img src="../../../assets/images/CategorizationOfWords.png" alt="words">
                        <h3>단어 분류</h3>
                        <p>사전에 추가한 단어를 올바른 철자, 기술적 절차 이름, 생물학적 이름, 제품 이름 등에 따라 구성할 수 있습니다. 트링카는 사용할수록 성능이 좋아집니다.
                        </p>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6">
                    <div class="features_cards">
                        <img src="../../../assets/images/AdjustCaseSensitivity.png" alt="case-sensitive">
                        <h3>대소문자 구분 조정</h3>
                        <p>대/소문자와 일치하는 경우 사전 용어를 무시할지 일치와 관계없이 무시할지 여부를 트링카에서 제어할 수 있습니다.
                        </p>
                    </div>
                </div>

                <div class="col-lg-4 col-md-6">
                    <div class="features_cards commingSoonTag">
                        <img src="../../../assets/images/ChooseEnglishType.png" alt="english">
                        <h3>영어 유형 선택</h3>
                        <p>트링카를 사용하면 추가된 용어를 영어 유형이 일치할 때 무시할지, 일치 여부와 관계 없이 무시할지 여부를 제어할 수 있습니다.
                        </p>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6">
                    <div class="features_cards commingSoonTag">
                        <span>기업</span>
                        <img src="../../../assets/images/MaintainBrandTone.png" alt="brand_tone">
                        <h3>브랜드 톤 유지</h3>
                        <p>조직에서 사용하는 어휘와 새 용어를 추가하여 모든 커뮤니케이션에서 브랜드 분위기를 유지하고 글쓰기 지원을 맞춤화해 보세요.</p>
                    </div>
                </div>

                <!-- <div class="col-lg-4 col-md-6">
                    <div class="features_cards commingSoonTag">
                        <img src="../../../assets/images/subjectAreaAndDocumentType.svg" alt="">
                        <h3>Advanced Controls</h3>
                        <p>With advanced controls, you can search for words and sort them too based on recent additions and
                            alphabetical order.</p>
                    </div>
                </div> -->

            </div>
        </div>
    </div>

    <div class="forpersonlized_sections">
        <p>맞춤 사전으로 나만의 글쓰기</p>
        <div class="forpersonlizedFooter">
            <a href="https://cloud.trinka.ai/signup?_rg=KR" target="_blank">시작하기</a>
        </div>
    </div>

    <div class="pricingQuestionAnwser" #target>
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="pricingHeadingQuestion">
                        <h2>자주하는 질문</h2>
                        <div class="HeadingSubLine"></div>
                    </div>
                </div>
                <div class="col-lg-1"></div>
                <div class="col-lg-10">
                    <div class="pricingQuestionsList">
                        <div class="accordion" id="faq">
                            <div class="card">
                                <div class="card-header" id="QuestionOne">
                                    <a href="#" class="btn btn-header-link" data-toggle="collapse" data-target="#QuestionOneContent" aria-expanded="true" aria-controls="QuestionOneContent">
                                        내가 추가한 단어에 다른 사람이 액세스할 수도 있나요?</a>
                                </div>

                                <div id="QuestionOneContent" class="collapse show" aria-labelledby="QuestionOne" data-parent="#faq">
                                    <div class="card-body">
                                        <p>나의 개인용 사전은 나만의 것입니다. 다른 사람이 액세스하거나 사용할 수 없습니다.</p>
                                    </div>
                                </div>
                            </div>
                            <div class="card">
                                <div class="card-header" id="QuestionTwo">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionTwoContent" aria-expanded="true"
                                        aria-controls="QuestionTwoContent">내 개인용 사전은 어디에서 찾을 수 있나요?</a>
                                </div>

                                <div id="QuestionTwoContent" class="collapse" aria-labelledby="QuestionTwo" data-parent="#faq">
                                    <div class="card-body">
                                        <p>
                                            <a href="https://cloud.trinka.ai/dashboard/profile" target="_blank">계정 설정</a>에서 찾을 수 있습니다. 글쓰기 설정 섹션에 내 사전 버튼이 표시되어 있습니다.</p>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="QuestionThree">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionThreeContent" aria-expanded="true"
                                        aria-controls="QuestionThreeContent">
                                        내 사전을 다른 계정과 공유할 수 있을까요?
                                    </a>
                                </div>

                                <div id="QuestionThreeContent" class="collapse" aria-labelledby="QuestionThree" data-parent="#faq">
                                    <div class="card-body">
                                        <p>내 사전은 나만의 것이며 다른 계정과 공유할 수 없습니다.</p>
                                    </div>
                                </div>
                            </div>
                            <div class="card">
                                <div class="card-header" id="QuestionFour">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionFourContent" aria-expanded="true"
                                        aria-controls="QuestionFourContent">
                                        내 개인용 사전을 다운로드할 수 있나요?
                                    </a>
                                </div>

                                <div id="QuestionFourContent" class="collapse" aria-labelledby="QuestionFour" data-parent="#faq">
                                    <div class="card-body">
                                        <p>현재는 사전을 다운로드할 수 없습니다. 그러나 곧 이 기능을 추가할 예정입니다.
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <!-- <div class="card">
                                <div class="card-header" id="QuestionFive">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionFiveContent" aria-expanded="true"
                                        aria-controls="QuestionFiveContent">
                                        나만의 개인용 사전으로 트링카 맞춤화하기
                                    </a>
                                </div>

                                <div id="QuestionFiveContent" class="collapse" aria-labelledby="QuestionFive" data-parent="#faq">
                                    <div class="card-body">
                                        <p>브랜드 이름이나 새로운 기술과 같이 트링카가 인식하지 못하는 단어를 개인용 사전에 추가하여 철자 오류 경고를 피해 보세요.
                                        </p>
                                    </div>
                                </div>
                            </div> -->
                        </div>
                    </div>
                </div>
                <div class="col-lg-1"></div>
            </div>
        </div>
    </div>
    <div class="use_trinka_other_app">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <div class="use_trinka_content">
                        <div class="use_trinka_heading">
                            <div class="howItWorkHeading lineWhiteColor">
                                <h2>다른 앱에서
                                    <br /> 트링카 사용</h2>
                                <div class="HeadingSubLine"></div>
                            </div>
                        </div>
                        <div class="others_app_name">
                            <ul>
                                <li>
                                    <a href="https://www.trinka.ai/kr/trinkacloud">
                                        <div class="app_name_content" routerLink="/trinkacloud">
                                            <div class="app_name_content_overlay"></div>
                                            <img src="../../../assets/images/Other_apps_TrinkaCloud.svg" alt="cloud">
                                            <h3>클라우드</h3>
                                        </div>
                                    </a>
                                </li>
                                <li>
                                    <a href="https://www.trinka.ai/kr/wordplugin">
                                        <div class="app_name_content" routerLink="">
                                            <div class="app_name_content_overlay"></div>
                                            <img src="../../../assets/images/Others_App_MSWord.svg" alt="ms word">
                                            <h3>MS Word 플러그인</h3>
                                        </div>
                                    </a>
                                </li>
                                <li>
                                    <a href="https://www.trinka.ai/kr/browser-plugin">
                                        <div class="app_name_content" routerLink="/browser-plugin">
                                            <div class="app_name_content_overlay"></div>
                                            <img src="../../../assets/images/other_Apps_browser.svg" alt="browser-icon">
                                            <h3>브라우저 플러그인</h3>
                                        </div>
                                    </a>
                                </li>
                                <li>
                                    <a href="https://www.trinka.ai/kr/enterprise">
                                        <div class="app_name_content" style="padding: 0px;" routerLink="/enterprise">
                                            <div class="app_name_content_overlay"></div>
                                            <img src="../../../assets/images/Other_Apps_enterprise.svg" alt="enterprise">
                                            <h3 style="margin: 0 0 -2px 0;">기업</h3>
                                            <span style="font-size: 12px; color: #000; position: relative;">(API, JS & On-Premise)
                                            </span>
                                        </div>
                                    </a>
                                </li>

                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Modal -->
<div class="modal fade" id="wordPluginPopup" tabindex="-1" role="dialog" aria-labelledby="wordPluginLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
            <div class="modal-body" style="padding: 0;">
                <button type="button" id="closedPopup" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
                <div id="iframeHolder"></div>

                <iframe class="youtubeVideoForTryDemo" id="iframe" width="100%" height="450" src="https://www.youtube.com/embed/5KsBh4PQUPI"
                    title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe>
                <!-- <iframe class="youtubeVideoForTryDemo" id="iframe" width="100%" height="450" src="https://www.youtube.com/embed/z-TVcRwVp3A"
                    title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe> -->
            </div>
        </div>
    </div>
</div>